import { useSelector } from "react-redux";
import { redirigirSegunUser } from "utils/generalFunctions";

const NotFound = () => {
  const { user } = useSelector((state) => state.auth);

  //Para cuando el usuario ponga una ruta que no está definida, que le redirija a su componente según el usuario
  return redirigirSegunUser(user);
};

export default NotFound;
